import { useParams, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useEffect, useState } from "react";
import { apiService } from "../services/apiService";
import Snooker from "./Scoreboards/Snooker";
import Pool from "./Scoreboards/Pool";
import UsPool from "./Scoreboards/UsPool";
import ChinesePool from "./Scoreboards/ChinesePool";

const ScoreBoard = () => {
    const { type, id } = useParams();
    const { user, loading, isAuthenticated } = useAuth();
    const [gameLoading, setGameLoading] = useState(true);
    const [gameOwnership, setGameOwnership] = useState(null);

    useEffect(() => {
        const checkGameOwnership = async () => {
            if (!user || !isAuthenticated()) return;
            try {
                const ownershipData = await apiService.post('/club/game/check-ownership', {
                    link: id,
                    user_id: user.id
                });
                setGameOwnership(ownershipData.belongs_to_user);
            } catch (error) {
                setGameOwnership(false);
            } finally {
                setGameLoading(false);
            }
        };

        if (!loading && user && isAuthenticated()) {
            checkGameOwnership();
        } else if (!loading) {
            setGameLoading(false);
        }
    }, [user, loading, isAuthenticated, id]);

    if (loading || gameLoading) {
        return (
            <div className="page-wrapper">
                <div className="page-body">
                    <div className="container-xl w-100">
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    if (!isAuthenticated() || !user) {
        return <Navigate to="/login" replace />;
    }
    if (gameOwnership === false) {
        return <Navigate to="/" replace />;
    }
    switch (type) {
        case 'snooker':
            return <Snooker />;
        case 'pool':
            return <Pool />;
        case 'us-pool':
            return <UsPool />;
        case 'chinese-pool':
            return <ChinesePool />;
        default:
            return <Navigate to="/" replace />;
    }
};

export default ScoreBoard;